import { InfoCircleOutlined } from '@ant-design/icons'
import { Card, Space, Statistic, StatisticProps, Tooltip } from 'antd'
import { valueType } from 'antd/es/statistic/utils'
import { FC, ReactNode, useMemo } from 'react'

type Props = StatisticProps & {
  value?: valueType
  compareTo?: number
  title: ReactNode
  help?: ReactNode
}

export const CampaignStatistic: FC<Props> = ({
  value,
  compareTo,
  title,
  help,
  ...rest
}) => {
  const text: string = useMemo(() => {
    if (value === null || value === undefined) return '--'
    let final = value.toString()
    if (compareTo) {
      const percentage = (100 * Number(value)) / compareTo
      final += ' - ' + percentage + '%'
    }
    return final
  }, [value, compareTo])

  return (
    <Card>
      <Statistic
        {...rest}
        value={text}
        title={
          <Space size={5}>
            {title}
            {help && (
              <Tooltip title={help}>
                <InfoCircleOutlined />
              </Tooltip>
            )}
          </Space>
        }
      />
    </Card>
  )
}
